import React from "react";
// import {
//   getZoomAuthUrl,
// } from "../../../services/uidata";
import { Formik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { updateUserTechnologies } from "../../../services/profile";
import { setLoading } from "../../../reducer/auth/auth";
import { useTranslation, Trans } from "react-i18next";

const StepThree = (props) => {
  const { t } = useTranslation("mediumRegisterSteps");
  const dispatch = useDispatch();
  const { test_mode } = useSelector(
    (state) => state.user.user
  );
  const { NextStep, PreviousStep, stepThreeData, setValues } = props;

  const RunFunction = (formData) => {
    dispatch(setLoading(true));
    setValues(formData, 3);
    const {
      electronicCalendars,
      zoomAccountType,
      preferredDevice,
      preferredBrowser,
      zoom_personal_link,
      paypal_me_link
    } = formData;
    let item = {
      calendar_type: electronicCalendars ,
      zoom_account_type: zoomAccountType,
      preferred_device: preferredDevice,
      preferred_browser: preferredBrowser,
      zoom_personal_link: zoom_personal_link,
      paypal_me_link: paypal_me_link
    };
    updateUserTechnologies(item)
      .then((data) => {
        dispatch(setLoading(false));
        if (data.data.status) {
          NextStep();
        }
      })
      .catch((err) => {
        dispatch(setLoading(false));
        console.log(err);
      });
  };
  // const getAuthUrl = ()=>{
  //   dispatch(setLoading(true));
  //   getZoomAuthUrl()
  //     .then((data) => {
  //       dispatch(setLoading(false));
  //       if (data.data.status) {
  //         window.open(data.data.data.redirect_url, "_blank");
  //       }
  //     })
  //     .catch((err) => {
  //       dispatch(setLoading(false));
  //       console.log(err);
  //     });
  // }
  const customHandleChange = (errors) => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const changeHandler = (event, electronicCalendars, setFieldValue) => {
    const noneIndex = electronicCalendars.indexOf("None");
    console.log(noneIndex);
    let array = electronicCalendars;
    if (event.target.checked && event.target.value === "None") {
      array = ["None"];
      setFieldValue("electronicCalendars", array);
    }
    if (event.target.checked && event.target.value !== "None") {
      if (noneIndex !== -1) {
        array.splice(noneIndex, 1);
      }
      array.push(event.target.value);
      setFieldValue("electronicCalendars", array);
    }
    if (!event.target.checked) {
      // array.splice(noneIndex, 1);
      const index = array.indexOf(event.target.value);
      array.splice(index, 1);
      setFieldValue("electronicCalendars", array);
    }
    console.log(array);
  };
  return (
    <Formik
      initialValues={stepThreeData}
      validate={(values) => {
        const errors = {};
        if (!values.electronicCalendars.length)
          errors.electronicCalendars = t("common:validation.required");
        if (!values.zoomAccountType) errors.zoomAccountType = t("common:validation.required");
        if (!values.preferredDevice.length) errors.preferredDevice = t("common:validation.required");
        if (!values.preferredBrowser.length)
          errors.preferredBrowser = t("common:validation.required");
        // if (!values.lastName) errors.lastName = "Required";
        // if (!values.phone) errors.phone = "Required";
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {
        RunFunction(values);
      }}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        setFieldValue,
        handleBlur,
        handleSubmit,
        isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <div className="from-inner-box radeo check-box-input payment-saction">
            <div className="full-fild">
              <label>{t("technology.calendarsLabel")}</label>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="googlecalendar"
                  type="checkbox"
                  value="Google Calendar"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Google Calendar")
                      ? true
                      : false
                  }
                />
                <label htmlFor="googlecalendar">{t("technology.calendars.google")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="icloundcalendar"
                  type="checkbox"
                  value="Cloud Calendar"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Cloud Calendar")
                      ? true
                      : false
                  }
                />
                <label htmlFor="icloundcalendar">{t("technology.calendars.icloud")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="Outlook"
                  type="checkbox"
                  value="Outlook"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Outlook")
                      ? true
                      : false
                  }
                />
                <label htmlFor="Outlook">Outlook</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="365calendar"
                  type="checkbox"
                  value="Office 365 Calendar"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Office 365 Calendar")
                      ? true
                      : false
                  }
                />
                <label htmlFor="365calendar">{t("technology.calendars.office365")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="exchangecalendar"
                  type="checkbox"
                  value="Exchange Calendar"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Exchange Calendar")
                      ? true
                      : false
                  }
                />
                <label htmlFor="exchangecalendar">{t("technology.calendars.exchange")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="othercalendar"
                  type="checkbox"
                  value="Other"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("Other") ? true : false
                  }
                />
                <label htmlFor="othercalendar">{t("options.other")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={(e) =>
                    changeHandler(e, values.electronicCalendars, setFieldValue)
                  }
                  onBlur={handleBlur}
                  id="nonecalendar"
                  type="checkbox"
                  value="None"
                  name="electronicCalendars"
                  checked={
                    values.electronicCalendars.includes("None") ? true : false
                  }
                />
                <label htmlFor="nonecalendar">{t("options.none")}</label>
              </div>
            </div>
            {!values.electronicCalendars.includes("Google Calendar") ?
              <label>{t("technology.googleCalendarNote")}</label> : ""}
            <span className="error margin-top-115">
              {errors.electronicCalendars &&
                touched.electronicCalendars &&
                errors.electronicCalendars}
            </span>

          </div>

          <div className="from-inner-box radeo check-box-input payment-saction in-order">
            <div className="full-fild">
              <label>
                {t("technology.zoomAccountLabel")}
              </label>
              {/* <p className="signup">
                <a onClick={getAuthUrl} href="javscript:void(0)">Sign up forCalendly here.</a>(Note: Limitations on free
                accounts)
              </p> */}
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="I have a paid account"
                  id="zoompaidacc"
                  type="radio"
                  name="zoomAccountType"
                  checked={
                    values.zoomAccountType === "I have a paid account"
                      ? true
                      : false
                  }
                />
                <label htmlFor="zoompaidacc">{t("technology.zoomAccount.paid")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="I have a free account"
                  id="zoomfreeaccount"
                  type="radio"
                  name="zoomAccountType"
                  checked={
                    values.zoomAccountType === "I have a free account"
                      ? true
                      : false
                  }
                />
                <label htmlFor="zoomfreeaccount">{t("technology.zoomAccount.free")}</label>
              </div>
              <div className="check-field">
                <input
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value="None"
                  id="nonezoomacc"
                  type="radio"
                  name="zoomAccountType"
                  checked={values.zoomAccountType === "None" ? true : false}
                />
                <label htmlFor="nonezoomacc">{t("options.none")}</label>
              </div>
            </div>
            <span className="error marg-top-55">
              {errors.zoomAccountType &&
                touched.zoomAccountType &&
                errors.zoomAccountType}
            </span>
          </div>
         {test_mode === 1 && <div class="from-inner-box ">
            <div class="full-fild">
              <label>{t("technology.zoomLinkLabel")}</label>
              <input
                className={`mb-2 ${
                  errors.zoom_personal_link &&
                  touched.zoom_personal_link &&
                  errors.zoom_personal_link
                    ? "error-boundry"
                    : ""
                }`}
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.zoom_personal_link}
                id="zoom_personal_link"
                name="zoom_personal_link"
                type="text"
                placeholder={t("technology.zoomLinkPlaceholder")}
              />
              <h6 className="form-h6">
                <Trans
                  i18nKey="technology.zoomLinkHelp"
                  ns="mediumRegisterSteps"
                  components={{
                    a: (
                      <a
                        href="https://support.zoom.us/hc/en-us/articles/201362843-Personal-meeting-ID-PMI-and-personal-link"
                        target="_blank"
                        rel="noopener noreferrer"
                      />
                    ),
                  }}
                />
              </h6>
            </div>
          </div>}
          <div class="from-inner-box radeo check-box-input all-devices">
            <div class="full-fild">
              <label>{t("technology.deviceLabel")}</label>
              <ul className="ul-li-list">
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="windows"
                      type="checkbox"
                      value="windows"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("windows")
                          ? true
                          : false
                      }
                    />
                    <label htmlFor="windows">
                      <Trans i18nKey="technology.devices.windows" ns="mediumRegisterSteps" />
                    </label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="tablet-ipad"
                      type="checkbox"
                      value="Mac"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("Mac") ? true : false
                      }
                    />
                    <label htmlFor="tablet-ipad"> Mac</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="tablet-android"
                      type="checkbox"
                      value="Tablet-iPad"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("Tablet-iPad")
                          ? true
                          : false
                      }
                    />
                    <label htmlFor="tablet-android">{t("technology.devices.tabletIpad")}</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="iPhone"
                      type="checkbox"
                      value="iPhone"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("iPhone") ? true : false
                      }
                    />
                    <label htmlFor="iPhone">iPhone</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="android"
                      type="checkbox"
                      value="Android"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("Android")
                          ? true
                          : false
                      }
                    />
                    <label htmlFor="android">Android</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="Otherdevice"
                      type="checkbox"
                      value="Other"
                      name="preferredDevice"
                      checked={
                        values.preferredDevice.includes("Other") ? true : false
                      }
                    />
                    <label htmlFor="Otherdevice">{t("options.other")}</label>
                  </div>
                </li>
              </ul>
            </div>
            <span className="error">
              {errors.preferredDevice &&
                touched.preferredDevice &&
                errors.preferredDevice}
            </span>
          </div>
          <div className="from-inner-box radeo check-box-input all-devices">
            <div className="full-fild">
              <label>{t("technology.browserLabel")}</label>
              <ul className="ul-li-list browser-saction">
                <li>
                  <div className="check-field">
                    <input
                      className="z-index-1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="chrome"
                      type="checkbox"
                      value="Google Chrome"
                      name="preferredBrowser"
                      checked={
                        values.preferredBrowser.includes("Google Chrome")
                          ? true
                          : false
                      }
                    />
                    <div className="icon-image  z-index-0">
                      <img src="images/chrome.png" alt="chromebrowser" />
                    </div>
                    <label htmlFor="chrome">
                      Google <br />
                      Chrome
                    </label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      className="z-index-1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="firefox"
                      type="checkbox"
                      value="FireFox"
                      name="preferredBrowser"
                      checked={
                        values.preferredBrowser.includes("FireFox")
                          ? true
                          : false
                      }
                    />
                    <div className="icon-image  z-index-0">
                      <img src="images/mozila.png" alt="FireFoxbrowser" />
                    </div>
                    <label htmlFor="firefox">FireFox</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      className="z-index-1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="edge"
                      type="checkbox"
                      value="Edge"
                      name="preferredBrowser"
                      checked={
                        values.preferredBrowser.includes("Edge") ? true : false
                      }
                    />
                    <div className="icon-image  z-index-0">
                      <img src="images/entnet.png" alt="Edgebrowser" />
                    </div>
                    <label htmlFor="edge">Edge</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      className="z-index-1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="safari"
                      type="checkbox"
                      value="Safari"
                      name="preferredBrowser"
                      checked={
                        values.preferredBrowser.includes("Safari")
                          ? true
                          : false
                      }
                    />
                    <div className="icon-image  z-index-0">
                      <img src="images/safari.png" alt="Safaribrowser" />
                    </div>
                    <label htmlFor="safari">Safari</label>
                  </div>
                </li>
                <li>
                  <div className="check-field">
                    <input
                      className="z-index-1"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      id="otherbrowser"
                      type="checkbox"
                      value="other"
                      name="preferredBrowser"
                      checked={
                        values.preferredBrowser.includes("other") ? true : false
                      }
                    />
                    <div className="icon-image z-index-0">
                      <img src="images/word-tow.png" alt="otherbrowser" />
                    </div>
                    <label htmlFor="otherbrowser">{t("options.otherLowercase")}</label>
                  </div>
                </li>
              
                <h6 className="note">{values.preferredBrowser.includes("other")?t("technology.browserNote"):''}</h6>
              </ul>
              <span className="error">
                {errors.preferredBrowser &&
                  touched.preferredBrowser &&
                  errors.preferredBrowser}
              </span>
            </div>
            <br />
            {/* <div className="left-side">
              <label>
                Paypal.me Link <span className="font-size-12">(only needed once you qualify for Outreach and Paying clients with us)</span>
              </label>
              <input
                onChange={handleChange}
                onBlur={handleBlur}
                value={values.paypal_me_link}
                type="text"
                id="paypal_me_link"
                name="paypal_me_link"
                placeholder="paypal link"
              />
            </div> */}
          </div>
          <input
            onClick={PreviousStep}
            type="button"
            name="previous"
            className="previous action-button-previous"
            value={t("buttons.back")}
          />
          <input
            type="submit"
            onClick={() => customHandleChange(errors)}
            name="next"
            className="next action-button"
            value={t("buttons.next")}
          />
        </form>
      )}
    </Formik>
  );
};
export default StepThree;
